import * as types from "../constants/actionTypes";


export const healthplanInitialState = {
    countOfLinkAAError: 0
};

export default function healthPlanReducer(state = healthplanInitialState, action) {
    switch (action.type) {
        case types.LOAD_HEALTHPLANDASHBOARD_START:
            return { ...state, error: false, isHealthPlanSuccess: false, isHealthPlanFailure: false, isFetching: true };
        case types.LOAD_HEALTHPLANDASHBOARD_SUCCESS:
            return { ...state, isFetching: action.isWaiting, isHealthPlanSuccess: true, healthPlanDashboardDetails: action.healthPlanDashboardData };
        case types.LOAD_HEALTHPLAN_DATA_START:
            return { ...state, healthPlanDataError: false, isHealthPlanDataPending: true, isHealthPlanDataSuccess: false, isHealthPlanDataFailed: false };
        case types.LOAD_HEALTHPLAN_DATA_SUCCESS:
            return { ...state, isHealthPlanDataPending: false, isHealthPlanDataSuccess: true, isHealthPlanDataFailed: false, healthPlanTileData: action.HealthPlanTileData, healthPlanDataError: false };
        case types.LOAD_HEALTHPLAN_DATA_FAILURE:
            return { ...state, isHealthPlanDataPending: false, isHealthPlanDataSuccess: false, isHealthPlanDataFailed: true, healthPlanTileData: null, healthPlanDataError: action.healthPlanDataError };
        case types.LINK_AUTO_HP_ACCOUNT_START:
            return { ...state, isAutoHPLinking: true, linkAutoHPSuccess: null, linkAutoHPError: false };
        case types.LINK_AUTO_HP_ACCOUNT_SUCCESS:
            return { ...state, isAutoHPLinking: false, linkAutoHPSuccess: "We've successfully linked your account.", linkAutoHPError: false };
        case types.LINK_AUTO_HP_ACCOUNT_FAILURE:
            return { ...state, isAutoHPLinking: false, linkAutoHPSuccess: null, linkAutoHPError: action.linkError };
        case types.LINK_AUTO_HP_ACCOUNT_CLEAR_MESSAGE:
            return { ...state, linkAutoHPSuccess: null, linkAutoHPError: null };


        case types.LINK_HEALTHPLAN_ACCOUNT:
            return { ...state, linkHP: { linking: true, success: false, error: null } };
        case types.LINK_HEALTHPLAN_ACCOUNT_SUCCESS:
            return { ...state, linkHP: { ...state.linkHP, linking: false, dob: action.dob, success: true, data: action.membershipProfile, successMessage: "We have successfully linked your account!", error: null } };
        case types.LINK_HEALTHPLAN_ACCOUNT_FAILURE:
            return { ...state, linkHP: { ...state.linkHP, linking: false, dob: action.dob, success: false, error: action.error } };
        case types.LINK_HEALTHPLAN_CLEAR_MESSAGE:
            return { ...state, linkHP: { linking: false, success: false, error: null } };

        case types.UNLINK_HEALTHPLAN_ACCOUNT:
            return { ...state, unlinkHP: { unlinking: true, success: false, error: null } };
        case types.UNLINK_HEALTHPLAN_ACCOUNT_SUCCESS:
            return { ...state, unlinkHP: { ...state.unlinkHP, unlinking: true, dob: action.dob, success: true, data: action.membershipProfile, successMessage: "We have successfully unlinked your account!", error: null } };
        case types.UNLINK_HEALTHPLAN_ACCOUNT_FAILURE:
            return { ...state, unlinkHP: { ...state.unlinkHP, unlinking: false, dob: action.dob, success: false, error: action.error } };
        case types.UNLINK_HEALTHPLAN_CLEAR_MESSAGE:
            return { ...state, unlinkHP: { unlinking: false, success: false, error: null } };

        case types.LINK_AA_ACCOUNT_START:
            return { ...state, linkAAError: false, linkAASuccess: null, isAALLinking: true };
        case types.LINK_AA_ACCOUNT_SUCCESS:
            return { ...state, isAALLinking: false, linkAASuccess: "We've successfully linked your account.", linkAAError: false, aalId: action.memberId || null };
        case types.LINK_AA_ACCOUNT_FAILURE:
            return { ...state, isAALLinking: false, linkAASuccess: null, linkAAError: action.linkError };
        case types.LINK_AA_ACCOUNT_ERROR_COUNT:
            if (action.countOfLinkAAError)
                return { ...state, countOfLinkAAError: 0 };
            else
                return { ...state, countOfLinkAAError: state.countOfLinkAAError + 1 };
        case types.LINK_AA_ACCOUNT_CLEAR_MESSAGE:
            return { ...state, linkAASuccess: null, linkAAError: null };

        case types.UNLINK_AA_ACCOUNT_START:
            return { ...state, unLinkAAError: false, unLinkAASuccess: null, isAALUnLinking: true };
        case types.UNLINK_AA_ACCOUNT_SUCCESS:
            return { ...state, isAALUnLinking: false, unLinkAASuccess: "We've successfully unlinked your account.", unLinkAAError: false };
        case types.UNLINK_AA_ACCOUNT_FAILURE:
            return { ...state, isAALUnLinking: false, unLinkAASuccess: null, unLinkAAError: action.unLinkAAError };
        case types.UNLINK_AA_ACCOUNT_CLEAR_MESSAGE:
            return { ...state, unLinkAASuccess: null, unLinkAAError: null };

        case types.LINK_FIRST_CARE_ACCOUNT:
            return { ...state, linkFirstCare: { linking: true, dob: action.dob, memberId: action.memberId, success: false, error: null } };
        case types.LINK_FIRST_CARE_ACCOUNT_SUCCESS:
            return { ...state, linkFirstCare: { ...state.linkFirstCare, linking: false, success: true, data: action.membershipProfile, successMessage: "We have successfully linked your account!", error: null } };
        case types.LINK_FIRST_CARE_ACCOUNT_FAILURE:
            return { ...state, linkFirstCare: { ...state.linkFirstCare, linking: false, success: false, error: action.error } };
        case types.LINK_FIRST_CARE_ACCOUNT_CLEAR:
            return { ...state, linkFirstCare: { linking: false, success: false, error: null } };

        case types.UNLINK_FIRST_CARE_ACCOUNT:
            return { ...state, unlinkFirstCare: { unlinking: true, memberId: action.memberId, success: false, error: null } };
        case types.UNLINK_FIRST_CARE_ACCOUNT_SUCCESS:
            return { ...state, unlinkFirstCare: { ...state.unlinkFirstCare, unlinking: false, success: true, data: action.membershipProfile, successMessage: "We have successfully unlinked your account!", error: null } };
        case types.UNLINK_FIRST_CARE_ACCOUNT_FAILURE:
            return { ...state, unlinkFirstCare: { ...state.unlinkFirstCare, unlinking: false, success: false, error: action.error } };
        case types.UNLINK_FIRST_CARE_ACCOUNT_CLEAR:
            return { ...state, unlinkFirstCare: { unlinking: false, success: false, error: null } };

        case types.LINK_DART_ACCOUNT:
            return { ...state, linkDart: { linking: true, dob: action.dob, success: false, error: null } };
        case types.LINK_DART_ACCOUNT_SUCCESS:
            return { ...state, linkDart: { ...state.linkDart, linking: false, success: true, data: action.data, successMessage: "We have successfully linked your account!", error: null } };
        case types.LINK_DART_ACCOUNT_FAILURE:
            return { ...state, linkDart: { ...state.linkDart, linking: false, success: false, error: action.error } };
        case types.LINK_DART_ACCOUNT_CLEAR:
            return { ...state, linkDart: { linking: false, success: false, error: null } };

        case types.UNLINK_DART_ACCOUNT:
            return { ...state, unlinkDart: { unlinking: true, success: false, error: null } };
        case types.UNLINK_DART_ACCOUNT_SUCCESS:
            return { ...state, unlinkDart: { ...state.unlinkDart, unlinking: false, success: true, data: action.data, successMessage: "We've successfully unlinked your account.", error: null } };
        case types.UNLINK_DART_ACCOUNT_FAILURE:
            return { ...state, unlinkDart: { ...state.unlinkDart, unlinking: false, success: false, error: action.error } };
        case types.UNLINK_DART_ACCOUNT_CLEAR:
            return { ...state, unlinkDart: { unlinking: false, success: false, error: null } };

        case types.LINK_WACO_ACCOUNT:
            return { ...state, linkWaco: { linking: true, dob: action.dob, success: false, error: null } };
        case types.LINK_WACO_ACCOUNT_SUCCESS:
            return { ...state, linkWaco: { ...state.linkWaco, linking: false, success: true, data: action.data, successMessage: "We have successfully linked your account!", error: null } };
        case types.LINK_WACO_ACCOUNT_FAILURE:
            return { ...state, linkWaco: { ...state.linkWaco, linking: false, success: false, error: action.error } };
        case types.LINK_WACO_ACCOUNT_CLEAR:
            return { ...state, linkWaco: { linking: false, success: false, error: null } };

        case types.UNLINK_WACO_ACCOUNT:
            return { ...state, unlinkWaco: { unlinking: true, success: false, error: null } };
        case types.UNLINK_WACO_ACCOUNT_SUCCESS:
            return { ...state, unlinkWaco: { ...state.unlinkWaco, unlinking: false, success: true, data: action.data, successMessage: "We've successfully unlinked your account.", error: null } };
        case types.UNLINK_WACO_ACCOUNT_FAILURE:
            return { ...state, unlinkWaco: { ...state.unlinkWaco, unlinking: false, success: false, error: action.error } };
        case types.UNLINK_WACO_ACCOUNT_CLEAR:
            return { ...state, unlinkWaco: { unlinking: false, success: false, error: null } };

        case types.AJAX_CALL_ERROR:
            return { ...state, isFetching: false, error: action.healthPlanError, isHealthPlanFailure: true };
        case types.USER_LOGGED_OUT:
            return { ...healthplanInitialState, error: action.errorCode };
        default:
            return { ...state };
    }
}